export const TERMS_OF_SERVICE_AND_PRIVACY_URL =
  'https://docs.google.com/document/d/1J1rYRvnkqzXOnbBoQ3PzjIrSZOTufAL4CJPoOBDq-fE/edit';

export const TERMS_OF_SERVICE_URL =
  'https://docs.google.com/document/d/1J1rYRvnkqzXOnbBoQ3PzjIrSZOTufAL4CJPoOBDq-fE/edit?tab=t.0#heading=h.r0a1ligr9xc4';

export const PRIVACY_URL =
  'https://docs.google.com/document/d/1CKGGLznQJZegswjyLa5WeT2ot1BfiaHn437g9vkRnl8/edit?tab=t.0';

export const DEMODAY_PRIVACY_URL = 'https://drive.google.com/file/d/1RIAyMlyuLYnipa6W_YBzcJ6hDzfH7yW3/view';
export const DEMODAY_TERMS_URL = 'https://drive.google.com/file/d/1MjOF66asddB_hsg7Jc-7Oxk6L1EvYHxk/view';
